/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import { makeApi, URLS } from 'Utils/apiUtil';
import userDetail from 'Stores/userDetail';
import advSearchState from 'Stores/advSearch';
import advSearchFilterPopupState from 'Stores/advSearchFIlterPopup';
import companySearchState from 'Stores/companySearch';
import { InputBoxWithSuggestion } from '../shared-component/inputBoxWithSuggestion';

let cancelCompanyKeywordCall = null;
const CompanyKeyword = observer(props => {
  const {
    placeHolderText = 'Keyword Search',
    isIncludeExcludeEnabled = false,
    filterInPage,
    currentTab = 'contact',
  } = props;
  // const suggestionKey = 'companyKeyword';
  const [inputVal, setInputVal] = React.useState('');
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  const [isExcludeEnabled, setIsExcludeEnabled] = React.useState(false);

  let currentSelectedState;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;

  const generateListSearchArr = (list = []) => {
    if (list.length) {
      const newList = list.map(item => {
        const newObj = {};
        newObj.pName = item;
        newObj.orgName = item;
        newObj.name = item;
        return newObj;
      });
      setSuggestionList(newList);
    } else {
      setSuggestionList([]);
    }
    // } else if (inputVal === '') {
    //   setSuggestionList([]);
    // } else {
    //   const newObj = {};
    //   newObj.pName = inputVal;
    //   newObj.orgName = inputVal;
    //   newObj.name = inputVal;
    //   setSuggestionList([newObj]);
    // }
  };

  const getSuggestion = () => {
    const config = {
      url: URLS.companyKeyword,
      method: 'POST',
      data: {
        q: inputVal,
      },
    };
    if (cancelCompanyKeywordCall !== null) {
      cancelCompanyKeywordCall('cancel');
      cancelCompanyKeywordCall = null;
    }
    const companyKeywordCancelCallback = value => {
      cancelCompanyKeywordCall = value;
    };
    setLoading(true);
    makeApi(config, false, companyKeywordCancelCallback)
      .then(response => {
        if (response && response.data) {
          setLoading(false);
          generateListSearchArr(response.data);
        }
      })
      .catch(error => {
        console.log('suggestionList error ', error);
      });
  };

  React.useEffect(() => {
    setNoMatchFound(false);
    if (inputVal === '') {
      setSuggestionList([]);
      if (cancelCompanyKeywordCall !== null) {
        cancelCompanyKeywordCall('cancel');
        cancelCompanyKeywordCall = null;
      }
    } else {
      getSuggestion();
    }
  }, [inputVal]);
  console.log('CompanyKeyword ', inputVal);

  const includeExcludeToggleCbk = () => {
    setIsExcludeEnabled(!isExcludeEnabled);
  };

  const callbackAction = (suggestionKey, arrObj) => {
    if (isExcludeEnabled) {
      currentSelectedState.setAppliedFilters(
        'excludeCompanyKeywordV2',
        arrObj,
        null,
        true,
        false,
      );
      const { appliedFilterData } = currentSelectedState;
      if (appliedFilterData.companyKeywordV2) {
        const data = appliedFilterData.companyKeywordV2.filter(
          prop => !arrObj.some(obj => obj.pName === prop.pName),
        );
        currentSelectedState.setAppliedFilters(
          'companyKeywordV2',
          data,
          null,
          false,
          true,
        );
      } else {
        currentSelectedState.setAppliedFilters(
          'excludeCompanyKeywordV2',
          arrObj,
          null,
          true,
          true,
        );
      }
    } else {
      currentSelectedState.setAppliedFilters(
        'companyKeywordV2',
        arrObj,
        null,
        true,
        false,
      );
      const { appliedFilterData } = currentSelectedState;
      if (appliedFilterData.excludeCompanyKeywordV2) {
        const data = appliedFilterData.excludeCompanyKeywordV2.filter(
          prop => !arrObj.some(obj => obj.pName === prop.pName),
        );
        currentSelectedState.setAppliedFilters(
          'excludeCompanyKeywordV2',
          data,
          null,
          false,
          true,
        );
      } else {
        currentSelectedState.setAppliedFilters(
          'companyKeywordV2',
          arrObj,
          null,
          true,
          true,
        );
      }
    }
  };

  return (
    <InputBoxWithSuggestion
      inputVal={inputVal}
      placeholder={placeHolderText}
      setInputVal={setInputVal}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      selectedItem={selectedItem}
      suggestionKey={
        isExcludeEnabled ? 'excludeCompanyKeywordV2' : 'companyKeywordV2'
      }
      includeSuggestionKey="companyKeywordV2"
      excludeSuggestionKey="excludeCompanyKeywordV2"
      // submitActionAllowed
      {...props}
      allowExcludeFilter={isIncludeExcludeEnabled}
      callbackAction={callbackAction}
      isExcludeEnabled={isExcludeEnabled}
      includeExcludeToggleCbk={includeExcludeToggleCbk}
      excludeToolTipInfo="Toggle here to include or omit keywords."
    />
  );
});

export { CompanyKeyword };
export default CompanyKeyword;
